import { call, put, fork, takeEvery } from 'redux-saga/effects';
import watchmatrixservicerequest from '../matrixservicerequest/services/matrixservicerequestSaga';

function* matrixservicerequestSaga() {
    yield fork(watchmatrixservicerequest);
}

export default matrixservicerequestSaga;
